import React, { useEffect, useState, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { AnalyticsEvent } from "../../components/elements/analytics-event";
const EventMilestoneOverlay = (props) => {
  const [state, setState] = useState({
    nextHeight: 0,
    next: "",
    load: "",
    loadSpeed: 0,
  });

  const heightRef = useRef(null);
  const timerVal = useRef(0);
  const first = useRef(0);
  const loadOut = useRef(0);
  const loadIn = useRef(0);

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/event-milestones/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.overlayStore.socketConnect(streamType, username, slug);

      let eventID = props.eventId || process.env.REACT_APP_EVENT_ID;

      props.eventStore.eventSocketConnect(eventID);
    }

    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const timer = urlParams.get("timer");

    timerVal.current =
      timer === "5"
        ? 300000
        : timer === "10"
        ? 600000
        : timer === "15"
        ? 900000
        : 300000;

    timer === "5" || timer === "10" || timer === "15"
      ? (first.current = setTimeout(() => start(), timerVal.current))
      : "";

    return () => {
      props.overlayStore.socketDisconnect(),
        props.eventStore.socketDisconnect();
      clearTimeout(first.current);
      clearTimeout(loadOut.current);
      clearTimeout(loadIn.current);
    };
  }, []);

  useEffect(() => {
    console.log("state: ", state);
  }, [state]);

  const start = () => {
    const { milestones } = props.overlayStore;

    // console.log("this ran");

    if (milestones.length > 0) {
      const setloadSpeed = heightRef.current.offsetHeight / 100;
      setState((prev) => {
        return {
          ...prev,
          nextHeight: heightRef.current.offsetHeight,
          load: " load-in",
          loadSpeed: setloadSpeed,
        };
      });
      loadOut.current = setTimeout(() => stop(), 20000);
    }
  };

  const stop = () => {
    setState((prev) => {
      return {
        ...prev,
        load: " load-out",
      };
    });
    console.log("stop state", state);
    loadIn.current = setTimeout(() => start(), timerVal.current);
  };

  const { milestones, raised, goal } = props.overlayStore;
  const { overallraised } = props.eventStore;
  const { load } = state;

  const formatNumber = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value
        .toFixed(2)
        .replace(/\.00$/, "")
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    }
    return value;
  };

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const visual = urlParams.get("visual");
  const bgColor = urlParams.get("bgColor");
  const timer = urlParams.get("timer");

  let milestonesArray = null;

  milestonesArray = milestones.map((milestones) => {
    const miltotal = Math.round(parseFloat(milestones.amount) - overallraised);
    const thermpercent = Math.round(
      100 * (parseFloat(overallraised) / parseFloat(milestones.amount))
    );
    const thermprogress = thermpercent > 100 ? 100 : thermpercent;
    return {
      key: milestones.id,
      name: milestones.name,
      amount: milestones.amount,
      active: milestones.amount > overallraised ? true : false,
      progress: thermprogress,
    };
  });

  const milestonesComplete = milestonesArray.filter((next) => !next.active);
  const milestonesNext = milestonesArray.filter((next) => next.active);
  const milestonesActive = milestonesNext.shift();

  const lastComplete = milestonesComplete[milestonesComplete.length - 1];

  const next = {
    height: state.nextHeight,
  };

  const loadStyle = {
    animationDuration: state.loadSpeed + "s",
  };

  const template = timer === "0" ? "all" : "one";

  return milestones.length > 0 ? (
    <div className={"milestone-overlay-wrapper " + `${visual} ${template}`}>
      {AnalyticsEvent("english", "/", "PLAY LIVE Milestone Overlay")}
      {template === "all" ? (
        <div className="all">
          {/* Active Milestones */}
          {milestonesActive !== undefined ? (
            <div
              className="milestone-overlay active"
              key={milestonesActive.key}
            >
              <div className="top left" />
              <div className="top right" />
              <div className="bottom left" />
              <div className="bottom right" />
              <div className={"milestone-overlay__bg " + bgColor} />

              <div className="milestone-overlay__bar">
                <div
                  className="milestone-overlay__bar__inner"
                  style={{
                    width: `${milestonesActive.progress}%`,
                  }}
                >
                  <span>
                    {milestonesActive.progress >= 10
                      ? milestonesActive.progress + "%"
                      : ""}
                  </span>
                </div>

                <div className="milestone-overlay__name">
                  <p>
                    ${formatNumber(milestonesActive.amount)} -{" "}
                    {milestonesActive.name}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* End Active Milestones */}

          {/* Completed/Next Milestones */}
          {milestonesActive !== undefined ? (
            <div className="milestone-overlay next">
              <div className="next__wrapper">
                {milestonesComplete.map((milestone) => (
                  <div key={milestone.key}>
                    <div className="milestone-overlay__bar">
                      <div
                        className="milestone-overlay__bar__inner completed"
                        style={{
                          width: `${milestone.progress}%`,
                        }}
                      >
                        <span className="completed_text">Completed</span>
                        <span>
                          {milestone.progress >= 10
                            ? milestone.progress + "%"
                            : ""}
                        </span>
                      </div>

                      <div className="milestone-overlay__name">
                        <p>
                          ${formatNumber(milestone.amount)} - {milestone.name}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}

                {milestonesNext.map((milestone) => (
                  <div key={milestone.key}>
                    <div className="milestone-overlay__bar">
                      <div
                        className="milestone-overlay__bar__inner"
                        style={{
                          width: `${milestone.progress}%`,
                        }}
                      >
                        <span>
                          {milestone.progress >= 10
                            ? milestone.progress + "%"
                            : ""}
                        </span>
                      </div>

                      <div className="milestone-overlay__name">
                        <p>
                          ${formatNumber(milestone.amount)} - {milestone.name}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : lastComplete !== undefined ? (
            <div>
              <div className="milestone-overlay next">
                <div className="next__wrapper">
                  {milestonesComplete.map((milestone) => (
                    <div key={milestone.key}>
                      <div className="milestone-overlay__bar">
                        <div
                          className="milestone-overlay__bar__inner completed"
                          style={{
                            width: `${milestone.progress}%`,
                          }}
                        >
                          <span className="completed_text">Completed</span>
                          <span>{milestone.progress}%</span>
                        </div>

                        <div className="milestone-overlay__name">
                          <p>
                            ${formatNumber(milestone.amount)} - {milestone.name}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* End Completed/Next Milestones */}
        </div>
      ) : template === "one" ? (
        <div className="one">
          {/* Active Milestones */}
          {milestonesActive !== undefined ? (
            <div
              className="milestone-overlay active"
              key={milestonesActive.key}
            >
              <div className="top left" />
              <div className="top right" />
              <div className="bottom left" />
              <div className="bottom right" />
              <div className={"milestone-overlay__bg " + bgColor} />

              <div className="milestone-overlay__bar">
                <div
                  className="milestone-overlay__bar__inner"
                  style={{
                    width: `${milestonesActive.progress}%`,
                  }}
                >
                  <span>
                    {milestonesActive.progress >= 10
                      ? milestonesActive.progress + "%"
                      : ""}
                  </span>
                </div>

                <div className="milestone-overlay__name">
                  <p>
                    ${formatNumber(milestonesActive.amount)} -{" "}
                    {milestonesActive.name}
                  </p>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* End Active Milestones */}

          {/* Completed/Next Milestones */}
          {milestonesActive !== undefined ? (
            <div className="milestone-overlay next" style={next}>
              <div
                className={"next__wrapper" + load}
                style={loadStyle}
                ref={heightRef}
              >
                {milestonesComplete.map((milestone) => (
                  <div key={milestone.key}>
                    <div className="milestone-overlay__bar">
                      <div
                        className="milestone-overlay__bar__inner completed"
                        style={{
                          width: `${milestone.progress}%`,
                        }}
                      >
                        <span className="completed_text">Completed</span>
                        <span>
                          {milestone.progress >= 10
                            ? milestone.progress + "%"
                            : ""}
                        </span>
                      </div>

                      <div className="milestone-overlay__name">
                        <p>
                          ${formatNumber(milestone.amount)} - {milestone.name}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}

                {milestonesNext.map((milestone) => (
                  <div key={milestone.key}>
                    <div className="milestone-overlay__bar">
                      <div
                        className="milestone-overlay__bar__inner"
                        style={{
                          width: `${milestone.progress}%`,
                        }}
                      >
                        <span>
                          {milestone.progress >= 10
                            ? milestone.progress + "%"
                            : ""}
                        </span>
                      </div>

                      <div className="milestone-overlay__name">
                        <p>
                          ${formatNumber(milestone.amount)} - {milestone.name}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : lastComplete !== undefined ? (
            <div>
              <div
                className="milestone-overlay completed"
                key={lastComplete.key}
              >
                <div className="top left" />
                <div className="top right" />
                <div className="bottom left" />
                <div className="bottom right" />
                <div className={"milestone-overlay__bg " + bgColor} />
              </div>

              <div className="milestone-overlay next" style={next}>
                <div
                  className={"next__wrapper" + load}
                  style={loadStyle}
                  ref={heightRef}
                >
                  {milestonesComplete.map((milestone) => (
                    <div key={milestone.key}>
                      <div className="milestone-overlay__bar">
                        <div
                          className="milestone-overlay__bar__inner completed"
                          style={{
                            width: `${milestone.progress}%`,
                          }}
                        >
                          <span className="completed_text">Completed</span>
                          <span>{milestone.progress}%</span>
                        </div>

                        <div className="milestone-overlay__name">
                          <p>
                            ${formatNumber(milestone.amount)} - {milestone.name}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* End Completed/Next Milestones */}
        </div>
      ) : (
        ""
      )}
    </div>
  ) : (
    // NO MILESTONES
    <div className="milestone-overlay-wrapper none">
      <p>Please add donation miletones to your campaign</p>
    </div>
  );
};

export default inject(
  "overlayStore",
  "eventStore"
)(observer(EventMilestoneOverlay));
